var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      ref: "userlist",
      staticClass: "userlist",
      attrs: { "aria-label": "User list for " + _vm.channel.name },
      on: { mouseleave: _vm.removeHoverUser },
    },
    [
      _c("div", { staticClass: "count" }, [
        _c("input", {
          ref: "input",
          staticClass: "search",
          attrs: {
            placeholder:
              _vm.channel.users.length +
              " user" +
              (_vm.channel.users.length === 1 ? "" : "s"),
            type: "search",
            "aria-label": "Search among the user list",
            tabindex: "-1",
          },
          domProps: { value: _vm.userSearchInput },
          on: {
            input: _vm.setUserSearchInput,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp",
                  ])
                ) {
                  return null
                }
                return _vm.navigateUserList($event, -1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown",
                  ])
                ) {
                  return null
                }
                return _vm.navigateUserList($event, 1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "page-up",
                    undefined,
                    $event.key,
                    undefined
                  )
                ) {
                  return null
                }
                return _vm.navigateUserList($event, -10)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "page-down",
                    undefined,
                    $event.key,
                    undefined
                  )
                ) {
                  return null
                }
                return _vm.navigateUserList($event, 10)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.selectUser.apply(null, arguments)
              },
            ],
          },
        }),
      ]),
      _c(
        "div",
        { staticClass: "names" },
        _vm._l(_vm.groupedUsers, function (users, mode) {
          return _c(
            "div",
            { key: mode, class: ["user-mode", _vm.getModeClass(mode)] },
            [
              _vm.userSearchInput.length > 0
                ? _vm._l(users, function (user) {
                    return _c("Username", {
                      key: user.original.nick + "-search",
                      attrs: {
                        "on-hover": _vm.hoverUser,
                        active: user.original === _vm.activeUser,
                        user: user.original,
                      },
                      domProps: { innerHTML: _vm._s(user.string) },
                    })
                  })
                : _vm._l(users, function (user) {
                    return _c("Username", {
                      key: user.nick,
                      attrs: {
                        "on-hover": _vm.hoverUser,
                        active: user === _vm.activeUser,
                        user: user,
                      },
                    })
                  }),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }